import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { css } from 'emotion';

import FormTextField from './FormTextField';
import { withTranslation } from 'react-i18next';

const divStyle = css`
  margin-bottom: 25px;
`;

class AddCatalogPriceContract extends Component {
  static propTypes = {
    className: PropTypes.string.isRequired,
    endDate: PropTypes.object,
    startDate: PropTypes.object
  };

  render() {
    const { className, t } = this.props;

    return (
      <div className={className}>
        <h5>{t('createContract:termEntryForm.contractNameLabel')}</h5>
        <Field
          className={divStyle}
          component={FormTextField}
          label={t('common:commonTerminology.contractName')}
          name="contractName"
        />
        <h5>{t('createContract:termEntryForm.notesToApproverLabel')}</h5>
        <Field
          component={FormTextField}
          label={t('createContract:termEntryForm.additionalInformationLabel')}
          name="comment"
          inputStyle={{ resize: 'vertical', minHeight: '150px', maxHeight: '300px' }}
          type="textarea"
        />
      </div>
    );
  }
}

export default withTranslation()(AddCatalogPriceContract);
